import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FETCH_ALL_LIMIT_EVENT } from 'config/fetchAll';

/**
 * BE-21（2026-10-11 PM 判断・文言承認）。全件取得が上限（5,000件）で止まったときの案内。
 *
 * 全件取得の呼び出し元（選択肢・一覧・CSV）は失敗の扱いがまちまちで、CSV の出力などは失敗を
 * 画面に出さない。fetchAll が止めたときに出すイベントを受け、画面の上部の1か所で知らせる。
 * 件数は表示言語の桁区切りで出す。「閉じる」で消す（次に止まったらまた出す）。
 */
const FetchAllLimitNotice: React.FC = () => {
  const { t, i18n } = useTranslation('common');
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    const show = (event: Event) => setCount((event as CustomEvent<{ count: number }>).detail.count);
    window.addEventListener(FETCH_ALL_LIMIT_EVENT, show);
    return () => window.removeEventListener(FETCH_ALL_LIMIT_EVENT, show);
  }, []);

  if (count === null) return null;
  // 件数の桁区切りは表示言語に合わせる（日付ではないので時間帯は関係しない）。
  const rows = new Intl.NumberFormat(i18n.language === 'en' ? 'en-US' : 'ja-JP').format(count);
  return (
    <div role="alert" className="flex items-start gap-4 m-4 p-3 rounded-md border border-red-300 bg-red-50 text-red-700">
      <p className="flex-1">{t('ui.fetch-all-limit', { rows })}</p>
      <button type="button" className="underline" onClick={() => setCount(null)}>
        {t('ui.close')}
      </button>
    </div>
  );
};

export default FetchAllLimitNotice;
